export default __webpack_public_path__ + "static/media/get-started.edbdbb3e.png";